import {request} from '@/helpers/apiClient'
import {PROMOTION_LIST_CONFIG} from '@/utils/constants/apiConfig/promotionListConfig'

export const getPromotionList = async (body, queryParams) =>
  request(PROMOTION_LIST_CONFIG.PROMOTIONS_LIST, {data: body}, queryParams)

export const downloadPromotionList = async (body, queryParams) =>
  request(PROMOTION_LIST_CONFIG.DOWNLOAD_PROMOTIONS_LIST, {data: body}, queryParams)
export const downloadPromotionTemplate = async (body, queryParams) =>
  request(
    PROMOTION_LIST_CONFIG.DOWNLOAD_PROMOTIONS_TEMPLATE,
    {
      responseType: 'arraybuffer',
    },
    ''
  )

export const getPromotionDetail = async promotionId => {
  const config = {...PROMOTION_LIST_CONFIG.PROMOTION_DETAIL}
  config.endPoint = config.endPoint.replace('{promotionId}', promotionId)
  return request(config)
}

export const downloadUploadedPromotionFile = async fileUploadId => {
  const config = {...PROMOTION_LIST_CONFIG.DOWNLOAD_UPLOADED_PROMOTION_FILE}
  config.endPoint = config.endPoint.replace('{fileUploadId}', fileUploadId)
  return request(config)
}

export const downloadPromotionFileUploadErrors = async (fileUploadId) => {
  const config = {...PROMOTION_LIST_CONFIG.DOWNLOAD_PROMOTION_FILE_UPLOAD_ERRORS}
  config.endPoint = config.endPoint.replace('{fileUploadId}', fileUploadId)
  return request(config)
}

export const getPromotionFileUploadErrors = async (fileUploadId) => {
  const config = {...PROMOTION_LIST_CONFIG.PROMOTION_FILE_UPLOAD_ERRORS}
  config.endPoint = config.endPoint.replace('{fileUploadId}', fileUploadId)
  return request(config)
}

export const getPromotionFileUploadHistory = async () => {
  const config = {...PROMOTION_LIST_CONFIG.PROMOTION_UPLOAD_HISTORY}
  return request(config)
}